import { FC, useContext } from 'react'
import {
  bookmarksBarTitle,
  DraggableBookmarkButton,
  InstallInstructionsByBrowser,
} from 'shared/add-babylist-button'
import Link from 'components/link'
import { track, useTracking } from 'lib/analytics'
import Slide, { Title } from '../Slide/Slide'
import { useNavigate } from 'react-router-dom-v5-compat'
import OnboardingAppContext from '../OnboardingAppContext'

interface AddButtonSlideProps {
  nextPath: string
  isOnboarding: boolean
  bookmarkletJS?: string
}

const AddButtonSlide: FC<AddButtonSlideProps> = ({
  nextPath,
  isOnboarding,
  bookmarkletJS,
}) => {
  const { bookmarkletJS: contextBookmarkletJS } =
    useContext(OnboardingAppContext)
  const tracker = useTracking()
  const _bookmarkletJS = bookmarkletJS || contextBookmarkletJS

  const navigate = useNavigate()

  const emitBabylistButtonTrackingEvent = () => {
    tracker.trackEvent({
      event: track.onboardingQuestionAnswered,
      eventLocation: track.EventLocation.ONBOARDING_MINUS_BABYLIST_BUTTON,
    })
  }

  const handleOnClick = () => {
    emitBabylistButtonTrackingEvent()
    if (isOnboarding) {
      window.location.href = nextPath
    } else {
      navigate(nextPath)
    }
  }

  return (
    <Slide>
      {isOnboarding && (
        <Link
          className="btn btn-info btn-empty btn-sm mbl"
          style={{ marginLeft: 'auto' }}
          onClick={handleOnClick}
        >
          Finish Setup
        </Link>
      )}
      <Title className="mbl">
        The Babylist button lets you add items from any store!
      </Title>
      <p>
        Drag the button below to your {bookmarksBarTitle()} bar to get started.
      </p>
      <DraggableBookmarkButton bookmarkletJS={_bookmarkletJS} />
      <Link onClick={handleOnClick}>Not right now</Link>
      <hr className="mvxl full-width" />
      <InstallInstructionsByBrowser />
    </Slide>
  )
}

export default AddButtonSlide
